module.exports = __webpack_public_path__ + "static/media/clock.4e2d4adf.svg";